<template>
  <section class="skillCard">
    <div id="skillHeader">
      <p id="headerIcon" :class="getIcon(skillSet.icon)"/>
      <h1>{{localizedTitle(skillSet.title)}}</h1>
    </div>
      <div id=skillsList>
      <ul>
        <li v-for="skill in skillSet.skills" :key="skill">{{localizedSkill(skill)}}</li>
      </ul>
      </div>
  </section>
</template>

<script>
export default {
  props: 
  [
    'skillSet'
  ],
  methods: {
    localizedTitle(localizedTitle) {
      return this.$t('skillSets.titles.' + localizedTitle)
    },
    localizedSkill(skill) {
      return this.$t('skillSets.skills.' + skill)
    },
    getIcon(icon) {
      return "fa " + icon
    }
  }
}
</script>

<style>
  .skillCard {
    background-color: white;
    border: solid 1px rgba(160, 160, 160, 0.3);
    width: 12rem;
    min-width: 12rem;
    max-width: 90%;
    height: 27rem;
    text-align: center;
  }
  .skillCard #skillHeader {
    width: 90%;
    display: inline-block;
    margin: 8px auto;
    text-align: center;
  }
  #skillHeader h1 {
    display: block;
    margin: 0 auto;
    margin-top: 0.5rem;
  }
  #skillHeader p {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 512 512'%3E%3Cpath d='M256,0l221.7,128v256L256,512L34.3,384V128L256,0z' fill='rgba(144, 144, 144, 0.1)' /%3E%3C/svg%3E");
    background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		color: #000000;
    display: inline-block;
		font-size: 1.5rem;
		height: 4rem;
		left: 0;
		line-height: 4rem;
		text-align: center;
		top: 0;
    width: 4rem;
    margin-bottom: 0;
  }
  #skillsList {
    padding-top: 0.5em;
    width: 100%;
    display: block;
    text-align: center;
  }

  #skillsList ul {
    display: inline-block;
    list-style-type: none;
    width: 95%;
    padding: 0;
    text-align: left;
  }
</style>

